import { assign } from 'xstate';
import inboxService from 'venuescanner-js/react/components/Inbox/services/inboxService';

export const actions = {
  updateThread: assign({
    thread: (context, event) => event.data?.thread || context.thread,
  }),
  refreshThread: assign({
    thread: (_context, event) => event.thread,
    space: (_context, event) => event.space,
    venue: (_context, event) => event.venue,
    organiser: (_context, event) => event.organiser,
    concierge: (_context, event) => event.concierge,
  }),
  saveCancellationReason: assign({
    cancellationReason: (_context, event) => event.reason,
  }),
  setActiveViewToChat: (context, _event) => {
    if (!context.isMobileDevice) {
      return;
    }

    context.setActiveViewToChat();
  },
  refreshCount: async () => {
    await inboxService.counts();
  },
};
